import { WEBSOCKET_MESSAGE_TYPES } from '../constants';

let globalWs: WebSocket | null = null;

export const setGlobalWebSocket = (ws: WebSocket | null) => {
  globalWs = ws;
};

export const useMetrics = () => {
  const logEvent = (event_type: string) => {
    if (globalWs?.readyState === WebSocket.OPEN) {
      globalWs.send(JSON.stringify({
        type: WEBSOCKET_MESSAGE_TYPES.FRONTEND_METRIC,
        event_type
      }));
    }
  };

  return { logEvent };
};
